import React, { createContext, useCallback, useEffect, useState, useContext, useRef } from "react";
import caAPI from "../services/caAPI";
import moment from "moment";
import Swal from "sweetalert2";
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import {AtendentesContext} from "./AtendentesContext";
import { PerfilUsuarioService } from "../services/PerfilUsuarioService";
import { WebSocketContext } from "./WebSocketContext";
import { infoToast, loadingToast, successToast } from "../components/DommusToast";

moment.locale('pt-br')

const atualizaLista = 1;

export const AtendimentoContext = createContext({});

export function AtendimentoProvider({ children }) {
  const { resolverNomeAtendente, mapaAtendentesGerenciados, validarUsuarioAtualAtendePorAtendimento } = useContext(AtendentesContext);
  const [atendimentoAtivo, setAtendimentoAtivo] = useState();
  const [listaAtendimentos, setListaAtendimentos] = useState([]);
  const listaAtendimentosRef = useRef([]);
  // Sempre aponta para as versões mais recentes das funções que dependem do filtro atual.
  // Os handlers de websocket são registrados uma única vez, então usam esta ref para não
  // ficarem presos ao filtro (e ao estado) da renderização em que foram registrados.
  const funcoesListaAtendimentosRef = useRef({});
  const [openFiltros, setOpenFiltros] = useState(false);
  const [filtro, setFiltro] = useState(null);
  const [pagina, setPagina] = useState(1);
  const [totalAtendimentos, setTotalAtendimentos] = useState(0);
  const [naoAtendidos, setNaoAtendidos] = useState(0);
  const [fetchingLista, setFetchingLista] = useState(false);
  const [loadingMensagens, setLoadingMensagens] = useState(false);
  const [filtrosFixados, setFiltrosFixados] = useState(null)
  const [assinaturaUsuario, setAssinaturaUsuario] = useState(null)
  const [mensagensAtualizadasWhatsapp, setMensagensAtualizadasWhatsapp] = useState(null)
  const [filtroSomenteNaoLidas, setFiltroSomenteNaoLidas] = useState(false);
  const [tipoAtendimentoSelecionado, setTipoAtendimentoSelecionado] = useState(null);
  const [atendentesSelecionados, setAtendentesSelecionados] = useState([]);
  const [totaisPorTipoAtendimento, setTotaisPorTipoAtendimento] = useState({});
  const [meiosComunicacaoSelecionados, setMeiosComunicacaoSelecionados] = useState([]);
  const [marcadoresSelecionados, setMarcadoresSelecionados] = useState([]);
  const [totalAtendimentosGeral, setTotalAtendimentosGeral] = useState(0);
  const [totaisMarcadores, setTotaisMarcadores] = useState({});
  const [isOpenInformacoesAtendimento, setIsOpenInformacoesAtendimento] = useState(false);
  const [openListaTiposAtendimentos, setOpenListaTiposAtendimentos] = useState(false);
  const [usuarioBloqueadoCriarTagInput, setUsuarioBloqueadoCriarTagInput] = useState(false);
  const [permitirVisualizarDadosTemplateTwilio, setPermitirVisualizarDadosTemplateTwilio] = useState(false);
  const [permitirEnviarAprovacaoTemplateTwilio, setPermitirEnviarAprovacaoTemplateTwilio] = useState(false);
  const [permitirReenviarAprovacaoTemplateTwilio, setPermitirReenviarAprovacaoTemplateTwilio] = useState(false);
  const [idDragActive, setIdDragActive] = useState(null);
  const [listaContatosOrigem, setListaContatosOrigem] = useState([]);
  const [buscandoAtendimentos, setBuscandoAtendimentos] = useState(false);
  const buscandoAtendimentosRef = useRef(false);
  const { channel } = useContext(WebSocketContext)
  const { promiseInProgress: promiseBuscaAtendimentoEmProgresso } = usePromiseTracker({ area: 'busca-atendimento-selecionado' })

  useEffect(() => {
    atualizarTotaisAtendimentos()
  }, [filtro]);

  useEffect(() => {
    listaAtendimentosRef.current = listaAtendimentos;
  }, [listaAtendimentos]);

  useEffect(() => {
    if(!atendimentoAtivo){
      setIsOpenInformacoesAtendimento(false);
    }
  },[atendimentoAtivo])

  useEffect(() => {
    // Escuta evento de atualização de cartão na lista de atendimento
    channel.unbind('cartao-atendimento-atualizado')
    channel.bind('cartao-atendimento-atualizado', function (dados) {
      const { handleAdiconaLista: adicionarNaLista, handleRemoveLista: removerDaLista } = funcoesListaAtendimentosRef.current
      if(validarUsuarioAtualAtendePorAtendimento(dados.atendimento)) {
        // Se for para mover ao topo, utiliza o handle de adicionar novo atendimento na lista sem duplicar.
        // Usa a versão mais recente para que o filtro atual (inclusive o fixado) seja aplicado.
        adicionarNaLista(dados.atendimento)
        // Se o evento tiver alguma mensagem enviada, dispara um toast, um exemplo é o de atendimento arquivado.
        if(dados.mensagem){
          infoToast.fire({ text: dados.mensagem })
        }
      } else {
        removerDaLista(dados.atendimento)
      }
    })
    return () => channel.unbind('cartao-atendimento-atualizado')
  }, [channel, mapaAtendentesGerenciados])

  const buscarSomenteNaoLidas = (status) => {
    if(buscandoAtendimentosRef.current) {
      return
    }
    setFiltroSomenteNaoLidas(status);
    let filtros = Object.assign(JSON.parse(caAPI.getLocalState('filtros') || "{}"), {somente_nao_lidas: status});
    filtros = Object.assign(filtros, {data_inicio: filtros.data_inicio ?? moment().format("YYYY-MM-DD")});

    filtrarListaAtendimentos(filtros, { limparAtendimentoAtivo: true });
  }

  const atualizarTotaisAtendimentos = () => {
    if(caAPI.getLocalState('token') && filtro){
      const novaPagina = 1;
      setPagina(novaPagina);      
      caAPI.atendimento.filtro.total(filtro).then(res => {
        const novoTotal = ( res.data && Number(res.data.total) ) || 0;
        const novoNaoAtendidos = ( res.data && Number(res.data.naoLidas) ) || 0;
        setTotalAtendimentosGeral(res.data?.total);
        setTotalAtendimentos(filtroSomenteNaoLidas ? novoNaoAtendidos : novoTotal);
        setNaoAtendidos(Number(novoNaoAtendidos))
        setTotaisPorTipoAtendimento(filtroSomenteNaoLidas ? res?.data?.total_tipos_atendimento_nao_lidos ?? {} : res?.data?.total_tipos_atendimento ?? {})
        setTotaisMarcadores(filtroSomenteNaoLidas ? res?.data?.total_marcadores_nao_lidos ?? {} : res?.data?.total_marcadores ?? {})
      }).catch(() => {
        Swal.fire({
          titleText: "Erro",
          text: "Não foi possivel buscar os dados filtrados",
          icon: 'error'
        });
      })
    }
  }

  const alterarBuscandoAtendimentos = (valor) => {
    buscandoAtendimentosRef.current = valor;
    setBuscandoAtendimentos(valor);
  }

  const filtrarListaAtendimentos = (filtrosEntrada, opcoes = {}) => {
    if(buscandoAtendimentosRef.current) {
      return
    }
    executarFiltroAtendimentos(filtrosEntrada, opcoes)
  }

  const executarFiltroAtendimentos = (filtrosEntrada, { mensagemCarregando = null, limparAtendimentoAtivo = false } = {}) => {
    alterarBuscandoAtendimentos(true);
    if(mensagemCarregando) {
      loadingToast.fire({ title: mensagemCarregando })
    }
    if(limparAtendimentoAtivo) {
      setAtendimentoAtivo(null);
    }
    setListaAtendimentos([])
    setTotalAtendimentos(0);
    setNaoAtendidos(0);
    let dataAtual = moment().format("YYYY-MM-DD");
    let filtros = filtrosEntrada;    
    if (!filtrosEntrada?.data_inicio) {
      filtros = Object.assign({}, { data_inicio: dataAtual, data_fim: dataAtual }, filtrosEntrada)
    }
    const novoFiltros = Object.assign({}, filtros);
    setOpenFiltros(false);    
    trackPromise(caAPI.atendimento.filtro.filtrar(filtros).then(res => {
        if(mensagemCarregando && loadingToast.isVisible()) {
          loadingToast.close()
        }
        setFiltro(novoFiltros);
        setListaAtendimentos(res.data)
        if(!limparAtendimentoAtivo && atendimentoAtivo?.id){
          const atendimentoRefresh = res?.data.find((atendimento) => atendimento.id === atendimentoAtivo.id);
          setAtendimentoAtivo(atendimentoRefresh);
        }
    }).catch(err => {
      Swal.fire({
        titleText: "Erro",
        text: "Não foi possivel buscar os dados filtrados",
        icon: 'error'
      });
    }).finally(() => alterarBuscandoAtendimentos(false)), "listaAtendimentosArea")
  };

  const setExportarFiltros = (filtrosEntrada, exportar = false, { mensagemCarregando = null, limparAtendimentoAtivo = false } = {}) => {
    if(buscandoAtendimentosRef.current) {
      return
    }
    alterarBuscandoAtendimentos(true);
    if(mensagemCarregando) {
      loadingToast.fire({ title: mensagemCarregando })
    }
    if(limparAtendimentoAtivo) {
      setAtendimentoAtivo(null);
    }
    setListaAtendimentos([])
    setTotalAtendimentos(0);
    setNaoAtendidos(0);
    let dataAtual = moment().format("YYYY-MM-DD");
    let filtros = filtrosEntrada; if (!filtrosEntrada.data_inicio) { filtros = Object.assign({}, { data_inicio: dataAtual, data_fim: dataAtual }, filtrosEntrada)
    }
    const novoFiltros = Object.assign({}, filtros);
    trackPromise(caAPI.atendimento.filtro.exportar(filtros, exportar).then(res => {
      if(res.headers['content-type'].replace(/;.+/, "") == 'text/csv'){
        const csvData = res.data;
        const blob = new Blob([csvData], { type: "text/csv" });
        const csvURL = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = csvURL;
        link.setAttribute('download', 'Filtro-pesquisa-conecta-'+ (new Date().toISOString()) +'.csv');

        document.body.appendChild(link);
        link.click();
        if(mensagemCarregando) {
          successToast.fire({ title: 'Relatório exportado com sucesso.' })
        }
      } else if(mensagemCarregando && loadingToast.isVisible()) {
        loadingToast.close()
      }
      executarFiltroAtendimentos(filtrosEntrada, { limparAtendimentoAtivo })
    }).catch(err => {
      alterarBuscandoAtendimentos(false);
      Swal.fire({
        titleText: "Erro",
        text: "Não foi possivel buscar os dados filtrados",
        icon: 'error'
      });
    }), "listaAtendimentosArea")
  };

  const handleAdiconaLista = (atendimento) => {
    if(!verificaAtendimentoValidoNaListaComFiltros(atendimento)) {
      // Remove os atendimentos da lista do atendente em tempo real
      handleRemoveLista(atendimento)

      return
    }
    if(atendimento && atendimento.id) {
      atendimento.msg_nao_lidas = atendimento.msg_nao_lidas || 1
      const atendimentoAtualizadoAntigo = listaAtendimentosRef.current.find(atendimentoLista => atendimentoLista.id && (Number(atendimentoLista.id) === Number(atendimento.id)))
      const primeiroAtendimentoDalista = Number(atendimentoAtualizadoAntigo?.id) === Number(listaAtendimentosRef.current?.[0]?.id)
      if(atendimentoAtualizadoAntigo && !primeiroAtendimentoDalista) {
        // Retira o elemento da lista, forçando a renderização da lista novamente (Animação de saída). 
        setListaAtendimentos(listaAtualAtendimentos => removerAtendimentoDaLista(listaAtualAtendimentos, atendimento.id))
      }
      let atendimentoNovo = { ...atendimento }
      if(!atendimentoNovo.nome_atendente) {
        atendimentoNovo.nome_atendente = resolverNomeAtendente(atendimentoNovo.atendente);
      }
      // Renderiza a lista com o elemento no topo após a conclusão da animação de saída.
      setTimeout(() => {
        if(atendimentoAtivo?.id === atendimento.id && atendimentoAtivo.ultima_movimentacao !== atendimento.ultima_movimentacao) {
          document.getElementById('scrollContainer')?.scrollTo({
            top: 0,
            behavior: 'instant' // Faz a rolagem ser instantânea
          })
        }
      }, 100)
      setTimeout(() => {
        // Se for o primeiro atendimento da lista, atualiza os dados sem fazer animação.
        if(primeiroAtendimentoDalista) {
           setListaAtendimentos(listaAtendimentosAtual => listaAtendimentosAtual.map((atendimentoLista, index) => {
            if(index) {
              return atendimentoLista
            }
            return atendimentoNovo
           }))
        } else {
          setListaAtendimentos(listaAtendimentosAtual => ordenarListaAtendimentosPorUltimaMovimentacao([atendimentoNovo, ...listaAtendimentosAtual]))
        }
        atualizaTotaisPorAtendimento(atendimentoNovo, true, atendimentoAtualizadoAntigo)
      }, 200)
    }
  }

  const handleRemoveLista = (atendimento) => {
    if(atendimento && atendimento.id){
      const atendimentoAtualizadoAntigo = listaAtendimentosRef.current.find(atendimentoLista => atendimentoLista.id && (Number(atendimentoLista.id) === Number(atendimento.id)))
      if(atendimentoAtualizadoAntigo){
          atualizaTotaisPorAtendimento(atendimento, false, atendimentoAtualizadoAntigo)
          setListaAtendimentos(listaAtualAtendimentos => removerAtendimentoDaLista(listaAtualAtendimentos, atendimento.id))
      }
    }
  }

  const handleAtualizaLista = useCallback((novosFiltros = null, opcoes = {}) => {
    if(!novosFiltros){
      novosFiltros = Object.assign({}, filtro);
    }
    filtrarListaAtendimentos(novosFiltros, opcoes)
  }, [filtro, atendimentoAtivo]);

  const handleClearFiltro = function () {
    let dataAtual = new Date(`${moment().format('YYYY-MM-DD')} 00:00:00`)
    localStorage.removeItem("@DommusCA-filtros");
    localStorage.removeItem("@DommusCA-filtrosCount");
    localStorage.removeItem("@DommusCA-modificadorCodigo");
    localStorage.removeItem("@DommusCA-modificadorContato");
    localStorage.removeItem("@DommusCA-modificadorProponenteEnvolvido");
    caAPI.setLocalState('filtros', JSON.stringify({ data_inicio: dataAtual, data_fim: dataAtual }));
    caAPI.setLocalState('filtrosCount', JSON.stringify({ data_inicio: dataAtual, data_fim: dataAtual }));
    setFiltro({ data_inicio: dataAtual, data_fim: dataAtual });
    setOpenFiltros(false);
  }

  const handleReloadAtendimento = function () {
    if(atendimentoAtivo && atendimentoAtivo.id){
      caAPI.atendimento.find(atendimentoAtivo.id).then(res => {
          setAtendimentoAtivo(res.data);
        }).catch(err => {
      })
    }

  }

  const atualizarAtendimentoLista = (indice, atendimento) => {
    const novaLista = listaAtendimentos.slice();
    novaLista.splice(indice, 1, atendimento);
    setListaAtendimentos(novaLista);
  };

  async function carregaConfiguracoesDoUsuario() {
    const filtros = await PerfilUsuarioService.show(caAPI.getLocalState('idUsuario') || 0)
      .then(res => {
        setAssinaturaUsuario(JSON.parse(res.data.assinatura))
        setUsuarioBloqueadoCriarTagInput(res.data.bloquear_criacao_tag_input)
        setPermitirVisualizarDadosTemplateTwilio(res?.data?.permitir_visualizar_dados_template_twilio ?? false)
        setPermitirEnviarAprovacaoTemplateTwilio(res?.data?.permitir_enviar_aprovacao_template_twilio ?? false)
        setPermitirReenviarAprovacaoTemplateTwilio(res?.data?.permitir_reenviar_aprovacao_template_twilio?? false)
        if(res.data?.filtros_fixados) {
          return res.data.filtros_fixados
        }
      })
      .catch(error => {
        Swal.fire({
          titleText: "Ooops...",
          text: `Houve um problema ao buscar as configurações do usuário. ${error}`,
          icon: 'error'
        })
      })
    return filtros
  }

  function removerAtendimentoDaLista(listaAtendimentos, idAtendimento) {
    return listaAtendimentos.filter(atendimentoLista => Number(atendimentoLista.id) !== Number(idAtendimento))
  }

  function ordenarListaAtendimentosPorUltimaMovimentacao(listaAtendimentos) {
    return listaAtendimentos.sort((a, b) => new Date(b.ultima_movimentacao) - new Date(a.ultima_movimentacao))
  }

  const checkExisteIdEmLista = (idAtendimento) => {
    let indiceAtendimento = listaAtendimentos.findIndex(atendimentoLista => atendimentoLista.id && (Number(atendimentoLista.id) === Number(idAtendimento)));
    return (indiceAtendimento > -1);
  }

  const limparAtendimentoAtivo = () => {
    setAtendimentoAtivo(null);
  }

  const atualizarMensagensMesWhatsapp =useCallback( () => {
    if(atendimentoAtivo && atendimentoAtivo.id){
      trackPromise(caAPI.atendimento.whatsapp.atualizarMensagensMes(atendimentoAtivo.id).then(res => {
          const novoMensagens = (Array.isArray(res.data) && res.data.slice()) || null;
          setMensagensAtualizadasWhatsapp(novoMensagens);
      }).catch(err => {
        Swal.fire({
          titleText: "Erro",
          text: "Não foi possivel buscar as mensagens do último mês",
          icon: 'error'
        });
      }))
    }
  }, [atendimentoAtivo]);

  const handleExecutaPesquisaTelaPrincipal = (filtros) => {
    if(buscandoAtendimentosRef.current) {
      return
    }
    caAPI.setLocalState('filtros', JSON.stringify(filtros));

    if(filtros?.tipo_atendimento?.length){
      filtros.tipo_atendimento = filtros?.tipo_atendimento.map((item) => item?.value ?? item);
    }

    if(filtros?.atendente?.length){
      filtros.atendente = filtros.atendente?.map((item) => item?.value ?? item);
    }
    if(filtros?.tag_atendimento){
      filtros.tag_atendimento = filtros.tag_atendimento.map((item) => item?.value ?? item);
    }
    if(filtros?.situacao){
      filtros.situacao = filtros?.situacao.map((item) => item?.value ?? item);
    }
    if(filtros?.contato_origem_ramal){
      filtros.contato_origem_ramal = filtros?.contato_origem_ramal.map((item) => item?.value ?? item);
      if(!filtros.contato_origem_ramal.length){
        delete filtros.contato_origem_ramal
      }
    }

    filtrarListaAtendimentos(filtros, { limparAtendimentoAtivo: true });
  }

  function atualizaTotaisPorAtendimento(atendimento, adicionarTotal=true, atendimentoAtualizadoAntigo=null) {
    const adicionarOuSubtrair = adicionarTotal && 1 || -1 
    const valorInicialAdicionarOuSubtrair = adicionarTotal && 1 || 0
    // Atualiza total não visualizados
    if(atendimentoAtivo?.id !== atendimento.id) {
      const atendimentoPossuiMsgNaoLida = Number(atendimento.msg_nao_lidas) > 0
      const atendimentoAntigoPossuiMsgNaoLida = Number(atendimentoAtualizadoAntigo?.msg_nao_lidas) > 0
      if(
        (!atendimentoAtualizadoAntigo && atendimentoPossuiMsgNaoLida) || 
        (atendimentoAtualizadoAntigo && (atendimentoAntigoPossuiMsgNaoLida != atendimentoPossuiMsgNaoLida))
      ) {
        setNaoAtendidos(total => total + (atendimentoPossuiMsgNaoLida ? 1 : -1))
      }
    }
    // Atualiza o total geral
    if((!atendimentoAtualizadoAntigo && adicionarTotal) || (!adicionarTotal && atendimentoAtualizadoAntigo)) {
      setTotalAtendimentos(total => total + adicionarOuSubtrair)
      setTotalAtendimentosGeral(total => total + adicionarOuSubtrair)
    }
    // Atualiza o total de atendimentos por tipo
    if(atendimento.tipo_atendimento?.id && atendimentoAtualizadoAntigo?.tipo_atendimento?.id != atendimento.tipo_atendimento?.id) {
      setTotaisPorTipoAtendimento(totais => {
        totais.total += adicionarOuSubtrair
        if(totais[atendimento.tipo_atendimento.id]) {
          totais[atendimento.tipo_atendimento.id] += adicionarOuSubtrair 
        } else {
          totais[atendimento.tipo_atendimento.id] = valorInicialAdicionarOuSubtrair
        }
        if(adicionarTotal === false && atendimentoAtualizadoAntigo?.tipo_atendimento?.id) {
          totais[atendimentoAtualizadoAntigo.tipo_atendimento.id] -= 1
        }
        return totais
      })
    }
    // Atualiza o total de atendimentos por tag
    if(atendimento.tags?.length) {
      let totalTagsAtualizado = totaisMarcadores
      atendimento.tags.forEach(tag => {
          totalTagsAtualizado.total += adicionarOuSubtrair
        if(totalTagsAtualizado[tag.id_tag]) {
          totalTagsAtualizado[tag.id_tag] += adicionarOuSubtrair
        } else {
          totalTagsAtualizado[tag.id_tag] = valorInicialAdicionarOuSubtrair
        }
      })
      setTotaisMarcadores(totalTagsAtualizado)
    } 
  }

  function verificaAtendimentoValidoNaListaComFiltros(atendimento) {
    if(Number(atendimento.arquivado) === 1) {
      if(atendimentoAtivo?.id == atendimento.id) {
        infoToast.fire({ text: 'Atendimento arquivado' })
        setAtendimentoAtivo(null);
      }
      return false
    }
    // Filtro de atendente.
    if(filtro?.atendente?.length && !filtro.atendente.map(atendente => Number(atendente)).includes(Number(atendimento.atendente))) {
      return false
    }
    // Filtro de contato destino.
    if(filtro?.contato_destino) {
      let contatoDestino = filtro.contato_destino
      if(filtro.contato_destino_tipo != 'email') {
        contatoDestino = contatoDestino.replace(/\D/g, '')
        if(contatoDestino.length > 8) {
          contatoDestino = contatoDestino.slice(-8)
        }
      }
      if(!atendimento.contato_destino?.toLowerCase().includes(contatoDestino.toLowerCase())) {
        return false
      }
    }
    // Filtro de data inicio da ultima movimentação.
    if(filtro?.data_inicio && moment(atendimento.ultima_movimentacao).isBefore(moment(filtro.data_inicio), 'day')) {
      return false
    }
    // Filtro de data final da ultima movimentação.
    if(filtro?.data_fim && moment(atendimento.ultima_movimentacao).isAfter(moment(filtro.data_fim), 'day')) {
      return false
    }
    // Filtro de data inicio da criação do atendimento.
    if(filtro?.data_criacao_inicio && moment(atendimento.criado_em).isBefore(moment(filtro.data_criacao_inicio), 'day')) {
      return false
    }
    // Filtro de data final da criação do atendimento.
    if(filtro?.data_criacao_fim && moment(atendimento.criado_em).isAfter(moment(filtro.data_criacao_fim), 'day')) {
      return false
    }
    // Filtro de tipo de atendimento.
    if(filtro?.tipo_atendimento?.length && !filtro.tipo_atendimento.map(idTipoAtendimento => Number(idTipoAtendimento)).includes(atendimento.tipo_atendimento.id)) {
      return false
    }
    // Filtro de situação de atendimento.
    if(filtro?.situacao?.length && !filtro.situacao.map(idSituacaoAtendimento => Number(idSituacaoAtendimento)).includes(atendimento.situacao_atendimento.id)) {
      return false
    }
    // Filtro de tag de atendimento.
    if(filtro?.tag_atendimento?.length && !filtro.tag_atendimento.some(tagFiltro => atendimento.tag?.map(tag => tag.id_tag).includes(tagFiltro))) {
      return false
    }
    // Filtro de atendimento que contém conteúdos não visualizados.
    if(filtro?.somente_nao_lidas && !atendimento.msg_nao_lidas) {
      return false
    }
    // Filtro de nome do contato do destinatário
    if(filtro?.nome && !atendimento.nome?.toLowerCase().includes(filtro.nome.toLowerCase())) {
      return false
    }
    // Filtro de meio de comunicação.
    if(filtro?.meio_comunicacao?.length && !filtro.meio_comunicacao.includes(atendimento.meio_comunicacao?.id)) {
      return false
    }
    // Filtro de contato origem com ramal
    const filtroContato = filtro?.contato_origem_ramal ? String(filtro.contato_origem_ramal).toLowerCase() : null
    const contatoAtendimento = `${String(atendimento.contato_destino || '').toLowerCase()}#${atendimento.ramal}`
    if(filtroContato && contatoAtendimento !== filtroContato) {
      return false
    }
    // Filtro por id do atendimento
    if(filtro?.id && Number(filtro.id) !=Number (atendimento.id)) {
      return false
    }
    // Filtro por id da oportunidade
    if(filtro?.oportunidade && Number(filtro.oportunidade) != Number(atendimento.oportunidade)) {
      return false
    }
    // Filtro por id do processo
    if(filtro?.processo && Number(filtro.processo) != Number(atendimento.processo)) {
      return false
    }
    // Filtro por codigo_relacionamento
    if(filtro?.codigo_relacionamento && Number(filtro.codigo_relacionamento) != Number(atendimento.codigo_relacionamento)) {
      return false
    }
    // Filtro de tickets.
    if(filtro?.ticket && !atendimento.idsTickets?.includes(Number(filtro.ticket))) {
      return false
    }
    // Filtro de nome do proponente
    if(filtro?.nome_proponente && !atendimento.nomesProponentes?.some(nomeProponente => nomeProponente?.toLowerCase().includes(filtro.nome_proponente.toLowerCase()))) {
      return false
    }
    // Filtro de nome do envolvido
    if(filtro?.nome_envolvido && !atendimento.nomesEnvolvidos?.some(nomesEnvolvido => nomesEnvolvido?.toLowerCase().includes(filtro.nome_envolvido.toLowerCase()))) {
      return false
    }
    // Filtro por id do empreendimento
    if(filtro?.empreendimento && Number(filtro.empreendimento) != Number(atendimento.empreendimento)) {
      return false
    }
    // Filtro por id da unidade
    if(filtro?.unidades?.length && !filtro.unidades.map(idUnidade => Number(idUnidade)).includes(Number(atendimento.unidade))) {
      return false
    }
    // Filtro por direção (seta que indica atendimento ativo ou receptivo)
    if(filtro?.direcao == 'A' && !atendimento.criado_por) {
      return false
    }
    if(filtro?.direcao == 'R' && atendimento.criado_por) {
      return false
    }
    return true
  }

  const handleArquivar = (idAtendimento = null) => {
    const arquivamento = { arquivado: "1" };
    const id = idAtendimento || atendimentoAtivo?.id;
    // Encontra o atendimento na lista para remover
    const atendimento = listaAtendimentos.find(a => a.id && Number(a.id) === Number(id));
    
    return trackPromise(
      caAPI.atendimento.update(arquivamento, id).then(res => {
        // Remove da lista
        if(atendimento) {
          handleRemoveLista(atendimento);
        }
        setAtendimentoAtivo(null);
        return res
      }).catch(err => {
        Swal.fire({
          titleText: "Erro",
          text: "Erro ao arquivar atendimento",
          icon: 'error'
        });
        throw err
      })
    )
  }

  function finalizarAtendimento(finalizado, idAtendimento){
    // Primeiro realiza a finalização do atendimento
    trackPromise(
      caAPI.atendimento.update(finalizado, idAtendimento).then(res => {
        handleAdiconaLista(res.data)
        setAtendimentoAtivo(null)

        // Após finalizar, pergunta se deseja arquivar
        Swal.fire({
          position: 'center',
          icon: "question",
          title: 'Deseja arquivar o atendimento?',
          showCloseButton: false,
          showCancelButton: true,
          confirmButtonText: 'Quero Arquivar o Atendimento',
          cancelButtonText: 'Quero manter o Atendimento',
          width: '400px',
          customClass: {
            confirmButton: 'btn btn-primary mb-1',
            cancelButton: 'btn btn-danger'
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            handleArquivar(idAtendimento).then(() => {
              Swal.fire({
                title: 'Sucesso!',
                text: 'Atendimento foi arquivado com sucesso!',
                icon: 'success'
              })
            }).catch(() => {})
          }
        })

        return res
      }).catch(err => {
        Swal.fire({
          titleText: "Erro",
          text: "Erro ao finalizar atendimento",
          icon: 'error'
        });
        throw err
      })
    )
  }

  function salvarDadosAtendimento(dados, idAtendimento, arquivarAtendimento=false){
    return trackPromise(
      caAPI.atendimento.update(dados, idAtendimento).then(res => {
        handleAdiconaLista(res.data)
        setAtendimentoAtivo(null)
        if(arquivarAtendimento){
          return handleArquivar(idAtendimento).then(() => {
            Swal.fire({
              title: 'Sucesso!',
              text: 'Atendimento foi arquivado com sucesso!',
              icon: 'success'
            })
          })
        }
        return res
      }).catch(err => {
        Swal.fire({
          titleText: "Erro",
          text: "Erro ao finalizar atendimento",
          icon: 'error'
        });
        throw err
      })
    )
  }

  function salvarAtendimentoFinalizado(dados){
    let finalizar = dados?.finalizar ?? false;
    delete dados.finalizar;
    if(finalizar){
      dados.situacao = 4;
      finalizarAtendimento(dados, atendimentoAtivo.id);
    }else{
      salvarDadosAtendimento(dados, atendimentoAtivo.id);
    }
  }

  funcoesListaAtendimentosRef.current = {
    handleAdiconaLista,
    handleRemoveLista,
    verificaAtendimentoValidoNaListaComFiltros,
  }

  return (
    <AtendimentoContext.Provider value={{
      funcoesListaAtendimentosRef,
      handleAdiconaLista,
      handleAtualizaLista,
      handleClearFiltro,
      handleReloadAtendimento,
      handleRemoveLista,
      atualizaLista,
      atendimentoAtivo,
      setAtendimentoAtivo,
      listaAtendimentos,
      setListaAtendimentos,
      filtrarListaAtendimentos,
      openFiltros,
      setOpenFiltros,
      filtro,
      setFiltro,
      totalAtendimentos,
      naoAtendidos,
      pagina,
      setPagina,
      fetchingLista,
      setFetchingLista,
      atualizarAtendimentoLista,
      loadingMensagens,
      setLoadingMensagens,
      filtrosFixados,
      setFiltrosFixados,
      carregaConfiguracoesDoUsuario,
      assinaturaUsuario,
      setAssinaturaUsuario,
      checkExisteIdEmLista,
      limparAtendimentoAtivo,
      setExportarFiltros,
      buscandoAtendimentos,
      atualizarMensagensMesWhatsapp,
      mensagensAtualizadasWhatsapp,
      setMensagensAtualizadasWhatsapp,
      filtroSomenteNaoLidas, 
      setFiltroSomenteNaoLidas,
      atualizarTotaisAtendimentos,
      tipoAtendimentoSelecionado,
      setTipoAtendimentoSelecionado,
      totaisPorTipoAtendimento,
      atendentesSelecionados,
      setAtendentesSelecionados,
      buscarSomenteNaoLidas,
      meiosComunicacaoSelecionados, 
      setMeiosComunicacaoSelecionados,
      totalAtendimentosGeral,
      marcadoresSelecionados,
      setMarcadoresSelecionados,
      totaisMarcadores,
      setTotaisMarcadores,
      handleExecutaPesquisaTelaPrincipal,
      isOpenInformacoesAtendimento,
      setIsOpenInformacoesAtendimento,
      openListaTiposAtendimentos,
      setOpenListaTiposAtendimentos,
      idDragActive, 
      setIdDragActive,
      verificaAtendimentoValidoNaListaComFiltros,
      promiseBuscaAtendimentoEmProgresso,
      handleArquivar,
      finalizarAtendimento,
      salvarAtendimentoFinalizado,
      usuarioBloqueadoCriarTagInput,
      listaContatosOrigem,
      setListaContatosOrigem,
      permitirVisualizarDadosTemplateTwilio, 
      permitirEnviarAprovacaoTemplateTwilio, 
      permitirReenviarAprovacaoTemplateTwilio
    }}>
      {children}
    </AtendimentoContext.Provider>
  )
}
